import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { actionCreators } from "./store";
import imgLoginLogo from "../../../assets/images/loginlogo.png";
import Footer from "../../../common/footer";
import "./style.css";

class LoginTel extends Component {
  render() {
    const {
      isUserTel,
      userTel,
      errUserTel,
      isErrorPhonePyzm,
      phonePyzm,
      errPhonePyzm,
      sendYzmText,
      isSendYzmText,
      sending,
      getSign,
      countdown,
      isManuBtnClick,
      validateUserTel,
      validatePhonePyzm,
      handleUserTelChange,
      handlePhonePyzmChange,
      loginf,
      handleEnterKey,
      getsigncode,
    } = this.props;
    return (
      <div className="lrlogint">
        <header>
          <div className="headerin mx1200 mauto clear posr">
            <img src={imgLoginLogo} className="fl m30t" alt="" />
          </div>{" "}
        </header>{" "}
        <div className="main">
          <div className="mainin mx1200 mauto posr">
            <div className="con posa">
              <div className="top textc">验证码登录 </div>{" "}
              <div className="down">
                <div className={isUserTel ? "item tel errorcon" : "item tel"}>
                  <input
                    type="text"
                    value={userTel}
                    ref={(node) => (this.userTelEl = node)}
                    placeholder="请输入手机号"
                    onChange={(ev) => handleUserTelChange(ev)}
                    onBlur={(ev) => validateUserTel(ev)}
                  />{" "}
                  {isUserTel ? (
                    <div className="error"> {errUserTel} </div>
                  ) : null}{" "}
                </div>{" "}
                <div
                  className={
                    isErrorPhonePyzm
                      ? "item pyzm clear errorcon"
                      : "item pyzm clear"
                  }
                >
                  <input
                    type="text"
                    maxLength="6"
                    value={phonePyzm}
                    ref={(node) => (this.phonePyzmEl = node)}
                    placeholder="请输入短信验证码"
                    onChange={(ev) => handlePhonePyzmChange(ev)}
                    onKeyPress={(ev) =>
                      handleEnterKey(
                        ev,
                        loginf,
                        this.userTelEl,
                        this.phonePyzmEl,
                        isUserTel,
                        isErrorPhonePyzm,
                        getSign
                      )
                    }
                    onBlur={(ev) => validatePhonePyzm(ev)}
                  />{" "}
                  {!isSendYzmText && !sending ? (
                    <span
                      className="bluebdbtn"
                      onClick={(ev) =>
                        getsigncode(
                          this.userTelEl,
                          isUserTel,
                          countdown,
                        )
                      }
                    >
                      {" "}
                      {sendYzmText}{" "}
                    </span>
                  ) : null}{" "}
                  {(!isSendYzmText && sending) || (isSendYzmText && sending) ? (
                    <span className="graybtn"> {sendYzmText} </span>
                  ) : null}{" "}
                  {isErrorPhonePyzm ? (
                    <div className="error"> {errPhonePyzm} </div>
                  ) : null}{" "}
                </div>{" "}
                <div className="item">
                  {" "}
                  {isManuBtnClick ? (
                    <button type="button" className="opacity8">
                      {" "}
                      登录中， 请稍后...{" "}
                    </button>
                  ) : (
                    <button
                      onClick={(ev) =>
                        loginf(
                          this.userTelEl,
                          this.phonePyzmEl,
                          isUserTel,
                          isErrorPhonePyzm,
                          getSign
                        )
                      }
                      type="button"
                      className="cursp"
                    >
                      {" "}
                      登录{" "}
                    </button>
                  )}{" "}
                </div>{" "}
                <div className="item btext clear">
                  <Link to="/login" className="c_333 fl">
                    密码登录{" "}
                  </Link>{" "}
                  <Link to="/register" className="c_333 fr">
                    没有账号？ 立即注册{" "}
                  </Link>{" "}
                </div>{" "}
              </div>{" "}
            </div>{" "}
          </div>{" "}
        </div>{" "}
        <Footer />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isUserTel: state.getIn(["logintel", "isUserTel"]),
    userTel: state.getIn(["logintel", "userTel"]),
    errUserTel: state.getIn(["logintel", "errUserTel"]),
    isErrorPhonePyzm: state.getIn(["logintel", "isErrorPhonePyzm"]),
    phonePyzm: state.getIn(["logintel", "phonePyzm"]),
    errPhonePyzm: state.getIn(["logintel", "errPhonePyzm"]),
    sendYzmText: state.getIn(["logintel", "sendYzmText"]),
    isSendYzmText: state.getIn(["logintel", "isSendYzmText"]),
    sending: state.getIn(["logintel", "sending"]),
    getSign: state.getIn(["logintel", "getSign"]),
    countdown: state.getIn(["logintel", "countdown"]),
    isManuBtnClick: state.getIn(["logintel", "isManuBtnClick"]),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    handleUserTelChange(e) {
      let val = e.target.value;
      dispatch(actionCreators.handleUserTelChange(val));
      dispatch(actionCreators.toggleUserTelErr(false, ""));
    },
    handlePhonePyzmChange(e) {
      let val = e.target.value;
      dispatch(actionCreators.handlePhonePyzmChange(val));
      dispatch(actionCreators.togglePhonePyzmErr(false, ""));
    },
    validateUserTel(e) {
      let val = e.target.value;
      if (val === "") {
        dispatch(actionCreators.toggleUserTelErr(true, "您还没有输入手机号."));
        return false;
      } else if (
        !/^(13[0-9]|14[579]|15[0-3,5-9]|16[5,6]|17[0135678]|18[0-9]|19[89])\d{8}$/.test(
          val
        )
      ) {
        dispatch(actionCreators.toggleUserTelErr(true, "手机格式不正确."));
        return false;
      } else {
        dispatch(actionCreators.toggleUserTelErr(false, ""));
        return false;
      }
    },
    validatePhonePyzm(e) {
      let val = e.target.value;
      if (val === "") {
        dispatch(
          actionCreators.togglePhonePyzmErr(true, "您还没有短信验证码.")
        );
        return false;
      } else {
        dispatch(actionCreators.togglePhonePyzmErr(false, ""));
        return false;
      }
    },
    getsigncode(userNameEl, isUserTel, countdown) {
      let userTel = userNameEl.value;
      if (userTel === "") {
        dispatch(actionCreators.toggleUserTelErr(true, "您还没有输入手机号."));
        userNameEl.focus();
        return false;
      } else if (
        !/^(13[0-9]|14[579]|15[0-3,5-9]|16[5,6]|17[0135678]|18[0-9]|19[89])\d{8}$/.test(
          userTel
        )
      ) {
        dispatch(actionCreators.toggleUserTelErr(true, "手机格式不正确."));
        userNameEl.focus();
        return false;
      }
      if (isUserTel) {
        userNameEl.focus();
        return false;
      }
      dispatch(actionCreators.getsigncode(userTel, countdown));
    },
    loginf(userTelEl, phonePyzmEl, isUserTel, isErrorPhonePyzm, getSign) {
      let userTel = userTelEl.value;
      let phonePyzm = phonePyzmEl.value;
      if (userTel === "") {
        dispatch(actionCreators.toggleUserTelErr(true, "您还没有输入手机号."));
        return false;
      } else if (
        !/^(13[0-9]|14[579]|15[0-3,5-9]|16[5,6]|17[0135678]|18[0-9]|19[89])\d{8}$/.test(
          userTel
        )
      ) {
        dispatch(actionCreators.toggleUserTelErr(true, "手机格式不正确."));
        userTelEl.focus();
        return false;
      } else if (phonePyzm === "") {
        dispatch(
          actionCreators.togglePhonePyzmErr(true, "您还没有短信验证码.")
        );
        return false;
      }
      if (isUserTel) {
        userTelEl.focus();
        return false;
      } else if (isErrorPhonePyzm) {
        phonePyzmEl.focus();
        return false;
      }
      dispatch(actionCreators.loginf(userTel, phonePyzm, getSign));
    },
    handleEnterKey(
      e,
      loginf,
      userTelEl,
      phonePyzmEl,
      isUserTel,
      isErrorPhonePyzm,
      getSign
    ) {
      if (e.nativeEvent.keyCode === 13) {
        loginf(userTelEl, phonePyzmEl, isUserTel, isErrorPhonePyzm, getSign);
      }
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginTel);
